import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/services/api/apiRequest";
import { useClerkSession } from "@/services/clerkSession";
import type { Me } from "../members.types";

/**
 * The viewer's member record — what the shell, the nav and every access
 * question read.
 *
 * Answers for somebody signed out too (`{signedIn: false, member: null}`),
 * which is why it waits for Clerk: a request that goes out before the session
 * exists carries no token and comes back as "signed out", and that answer then
 * sits in the cache under the same key as the real one. The user id is part of
 * the key, so signing in and signing out are separate entries rather than one
 * that has to be invalidated by hand.
 *
 * `enabled` is still honoured by callers that pass it (they pass `clerkEnabled`
 * to keep the query off entirely in an unconfigured build).
 */
export function useMe(enabled = true) {
  const { isLoaded, userId } = useClerkSession();
  return useQuery<Me>({
    queryKey: ["afell", "me", userId ?? "anonymous"],
    queryFn: () => apiRequest("/afell/me/"),
    enabled: enabled && isLoaded,
  });
}

export default useMe;
